import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import DescriptiveSelectionConfig from "@widgets/DescriptiveSelection/DescriptiveSelection.skeleton"
import PermissionToggleConfig from "@widgets/PermissionToggle/PermissionToggle.skeleton"
import ImagesCarouselConfig from "../../widgets/ImagesCarousel/ImagesCarousel.skeleton"

const ButtonConfig = [{ span: 10, height: "40px", classes: "marginTop-48" }]
const VerticalDivider = [{ span: 2 }]
const SeparatorConfig1 = [{ span: 12, height: "8px", classes: "marginTop-24" }]
const FootnoteConfig = [{ span: 10, height: "70px", classes: "marginTop-40" }]
const AddressSelectionCofig = [{ span: 12, height: "42px", classes: "marginTop-32" }]

function DioProcessRequestSkeleton() {
    return (
        <div className="page-container">
            <div className="container-fluid flex">
                <div className="flex-column">
                    <Skeleton config={AddressSelectionCofig} isComponent></Skeleton>
                    <Skeleton config={SeparatorConfig1} isComponent></Skeleton>
                    <Skeleton config={DescriptiveSelectionConfig} isComponent></Skeleton>
                    <Skeleton config={SeparatorConfig1} isComponent></Skeleton>
                    <Skeleton config={PermissionToggleConfig} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={VerticalDivider} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={ImagesCarouselConfig} isComponent></Skeleton>
                    <Skeleton config={ButtonConfig} isComponent></Skeleton>
                    <Skeleton config={FootnoteConfig} isComponent></Skeleton>
                </div>
            </div>
        </div>
    )
}

export default DioProcessRequestSkeleton
